export default __webpack_public_path__ + "static/media/peopleResponsive_en.1b301881.png";